import { ArticleShell } from './ArticleShell';
import { SourcesBlock } from './SourcesBlock';

export function Mindfulness() {
    return (
        <>
            <ArticleShell>
                <h1 className="mb-30 text-mobile-display-2">
                    Du har måske hørt ordet før: Mindfulness. Men hvad er det
                    helt præcist for en størrelse?
                </h1>

                <p className="mb-30 text-body">
                    Mindfulness kan beskrives som et mentalt og kropsligt
                    stadie, hvor man er opmærksom på egne tanker, følelser og
                    omgivelser – uden at dømme dem og uden at lade sig rive sig
                    med. Der er mange måder at være mindful på. Det kan være
                    bestemte mindfulnessøvelser, at man laver en
                    dagligdagsaktivitet meget bevidst og nærværende (f.eks. at
                    være i bad), at lave en kropsscanning, at øve sig i at være
                    ikke-dømmende og empatisk overfor sig selv og andre. Og nej,
                    hvis det ikke føles rigtigt, behøver du ikke lave
                    mindfulness i skrædderstilling i en time ad gangen. Det kan
                    tage fem minutter og gøres stående, hvis det passer bedre
                    til dig.
                </p>

                <p className="mb-30 text-body">
                    Det vigtigste er, at det gøres på måder, der er relevant for
                    ens egen hverdag.
                </p>

                <p className="mb-30 text-body">
                    Mange kan være skeptiske i forhold til mindfulness og tro,
                    at det kun er for bestemte mennesker. Men mindfulness kan
                    være for alle. På tværs af uddannelser eller uden
                    uddannelse. På tværs af personlighedstyper.
                </p>

                <div className="rounded-[10px] bg-dark-red-10p">
                    <div className="p-20">
                        <h2 className="mb-20 text-mobile-display-1">
                            Her er nogle fordele ved mindfulness
                        </h2>

                        <ul className="list-disc pl-20 text-body">
                            <li className="mb-20">
                                Sænker kroppens stressniveau
                            </li>
                            <li className="mb-20">
                                Reducerer tankemylder og overdrevet grubleri og
                                bekymring
                            </li>
                            <li className="mb-20">
                                Kan hjælpe med følelsesregulering
                            </li>
                            <li className="mb-20">Forbedrer ens fokus</li>
                            <li className="mb-20">
                                Kan give perspektiv på tingene. At det er muligt
                                at være i svære situationer og fejle, uden at gå
                                i stykker. At rejse sig op og fortsætte på
                                trods.
                            </li>
                            <li className="mb-20">
                                Kan gøre os mere medfølende overfor andre
                                mennesker og mere villig til at hjælpe.
                            </li>
                            <li className="mb-20">Bedre søvnkvalitet</li>
                            <li>Emotionel intelligens</li>
                        </ul>
                    </div>
                </div>

                <p className="mb-20 mt-30 text-body">
                    Længden af øvelserne er ikke så afgørende – det er det til
                    gengæld, at øvelserne er noget, man bliver ved med. At få
                    erfaring med øvelserne og blive vant dem som passer en
                    bedst.
                </p>

                <p className="my-20 text-body">
                    Vores hjerner er det, man kalder for plastiske. Vores
                    hjerner kan med andre ord ændre sig alt efter de erfaringer,
                    som vi gør os og det, vi har fokus på. Særligt områder der
                    har med problemløsning, emotionsregulering, indlæring og
                    hukommelse at gøre menes at blive styrket, når man
                    eksperimenterer med mindfulness over en periode.
                </p>

                <p className="mt-20 text-body">
                    Og tro det eller ej, selv erfarne mennesker, der laver
                    mindfulnessøvelser, kan have tankemylder og blive
                    distraheret undervejs. Så det er helt okay, hvis det ikke
                    altid opleves så nemt.
                </p>
            </ArticleShell>
            <SourcesBlock
                sources={[
                    'American Psychological Association (2012): What are the benefits of mindfulness',
                    'Dexing Zhang, Eric K P Lee, Eva C W Mak, C Y Ho, Samuel Y S Wong (June, 2021): Mindfulness-based interventions: an overall review, British Medical Bulletin, Volume 138, Issue 1, Pages 41–57 — https://doi.org/10.1093/bmb/ldab005',
                    'Psykiatrifonden, Det Mentale Motionscenter: Mindfulness — https://psykiatrifonden.dk/hjaelp-raadgivning/mentale-motionscenter/mentale-motionscenter-mindfulness',
                ]}
            />
        </>
    );
}
